import {getDatabase, onValue, ref as userSyncRef} from "firebase/database";


//Stany usera:

//3. Wylogowany - authedUser === null - wyczyszczenie stanu loggedUser

//1. Zalogowany niezweryfikowany - authedUser.currentUser.emailVerified === false - konto powstaje w FB ze statusem niezweryfikowany

//2. Zalogowany zweryfikowany - authedUser.currentUser.emailVerified === true - synchronizacja danych z FB ze zmianą stanu veryfied na true

//4. Zalogowany, mail zweryfikowany ale nie uzupełnił podstawowego info - brak loggedUser - dokończenie rejestracji

//5.wejście w userPanel bez logowania,  authedUser === null

const UserSyncWithFireBase = (authedUser, setModalInfo, setModalVersion, setShowPopUpModal, setLoggedUser) => {
 // console.log('[UserSyncWithFireBase] function called'); // 💡 sprawdzenie wywołania
 // console.log('authedUser.currentUser:', authedUser.currentUser);

  const db = getDatabase();
  const response = userSyncRef(db, 'users');

  return onValue(response, (snap) => {
    console.log(snap); // 💡 sprawdzenie snapshotu
    if (snap.exists()) {
      const data = snap.val();
      console.log('Firebase users data:', data);

      if (!authedUser.currentUser) {
        console.log('User not logged in, clearing state');
        setLoggedUser('');
        return;
      } else if (authedUser.currentUser.emailVerified === false && Object.values(data).filter(i => i.email === authedUser.currentUser.email).length === 0) {
        console.log('User logged in but email not verified and not in DB, show modal');
        setModalInfo({title: 'Proszę uzupełnić podstawowe dane'});
        setModalVersion(8);
        setShowPopUpModal(true);
        return;
      } else if (authedUser.currentUser.emailVerified === true && Object.values(data).filter(i => i.email === authedUser.currentUser.email).length) {
        console.log('User verified and exists in DB, set loggedUser');
        setLoggedUser(Object.values(data).filter(i => i.email === authedUser.currentUser.email)[0]);
        return;
      } else if (authedUser.currentUser.emailVerified === true && Object.values(data).filter(i => i.email === authedUser.currentUser.email).length === 0) {
        console.log('User verified but not in DB, show modal');
        setModalInfo({title: 'Proszę uzupełnić podstawowe dane'});
        setModalVersion(8);
        setShowPopUpModal(true);
        return;
      }
    } else {
      console.log('No data in Firebase for users');
    }
  });
};

export default UserSyncWithFireBase;